import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  api_endpoint,
  adminRoot,
  basename,
  socketio_url
} from '../../constants/defaultValues';
import 'sweetalert2/dist/sweetalert2.min.css';
import Swal from 'sweetalert2/dist/sweetalert2';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import {
  SURVEY_GET_DETAILS,
  SURVEY_DELETE_QUESTION,
  SURVEY_DELETE_PAGE,
  UPT_TO_SERVER,
  ADD_QUES,
  UPT_QUES,
  UPT_FORM,
  UPT_QUES_OBJ,
  SET_ACTIVE,
  SET_FORCE,
  SURVEY_LIST_DEL,
  UPT_LAUNCH_SERVER,
} from '../actions';
import { io } from "socket.io-client";

import {
  getSurveyDetailSuccess,
  getSurveyDetailError,
  saveSurvey,
  deleteSurveyItemSuccess,
  deleteSurveyItemError,
  getSurveyUpt,
} from './actions';

import surveyDetailData from '../surveyques.json';
import { faCommentsDollar } from '@fortawesome/free-solid-svg-icons';


// Server Connect
const UpttoServer = async (id, sur) => {
  return await new Promise((success, err) => {
    let formData = new FormData();
    let surveydata = sur
    surveydata.pages.map((page) => {
      return page.questions.map((question) => {
        if (question.imgFiles !== undefined) {
          question.imgFiles.map((file) => {
            formData.append(sur.iid + ',' + question.id, file);
          });
        }
      });
    });
    formData.append('surveyData', JSON.stringify(surveydata));
    axios.put(
      api_endpoint + '/survey/' + sur.iid + '/' + sur.id,
      formData,
      {
        headers: { 'Authorization': 'bearer ' + localStorage.getItem('gpfkey') }
      }
    ).then(response => {
      localStorage.setItem('gpfkey', response.data.token)
      // console.log(response.data.data);
        surveyDetailData.data[0] = response.data.data
      success(response.data.data[0]);
    }).catch(function (err) {
      if (err == undefined || err.response == undefined || err.response.status == undefined) {
        Swal.fire({
          html: '<h3>พบข้อผิดพลาดการเชื่อมต่อกับเซิฟเวอร์ กรุณาลองใหม่อีกครั้ง</h3>',
          confirmButtonText: `ปิด`,
          icon: 'error',
          didClose: () => {
            success(sur)
          }
        });
      } else if (err.response.status == 401) {
        localStorage.removeItem('gpfsp');
        sessionStorage.setItem('previous', window.location.href);
        Swal.fire({
          html: '<h3>ระบบไม่ได้รับการตอบสนองจากผู้ใช้งานภายในเวลาที่กำหนด กรุณาออกจากระบบ</h3>',
          confirmButtonText: `ปิด`,
          icon: 'info',
          didClose: () => {
            window.location.href = (basename + "/user/login")
          }
        });
      }
    });
  })
    .then((response) => response)
    .catch((error) => error);
};

const uptDateServer = async (id, old, sur) => {
  return await new Promise((success, err) => {
    let formData = new FormData();
    let surveydata = sur
    surveydata.pages.map((page) => {
      return page.questions.map((question) => {
        if (question.imgFiles !== undefined) {
          question.imgFiles.map((file) => {
            formData.append(sur.iid + ',' + question.id, file);
          });
        }
      });
    });
    formData.append('surveyData', JSON.stringify(surveydata));
    axios.put(
      api_endpoint + '/survey/' + sur.iid + '/' + sur.id,
      formData,
      {
        headers: { 'Authorization': 'bearer ' + localStorage.getItem('gpfkey') }
      }
    ).then(r => {
      // console.log(response.data.data);
      axios.post(
        api_endpoint + '/getSurveyRound/' + sur.iid + '/' + sur.id,
        {},
        {
          headers: { 'Authorization': 'bearer ' + localStorage.getItem('gpfkey') }
        }
      ).then(response => {
        localStorage.setItem('gpfkey', response.data.token)
        surveyDetailData.data[0] = r.data.data[0]
        success({ sur: r.data.data[0], round: (response.data.round) });
      }).catch(function (err) {
        if (err == undefined || err.response == undefined || err.response.status == undefined) {
          Swal.fire({
            html: '<h3>พบข้อผิดพลาดการเชื่อมต่อกับเซิฟเวอร์ กรุณาลองใหม่อีกครั้ง</h3>',
            confirmButtonText: `ปิด`,
            icon: 'error',
          });
        } else if (err.response.status == 401) {
          localStorage.removeItem('gpfsp');
          sessionStorage.setItem('previous', window.location.href);
          Swal.fire({
            html: '<h3>ระบบไม่ได้รับการตอบสนองจากผู้ใช้งานภายในเวลาที่กำหนด กรุณาออกจากระบบ</h3>',
            confirmButtonText: `ปิด`,
            icon: 'info',
            didClose: () => {
              window.location.href = (basename + "/user/login")
            }
          });
        }
      });
    }).catch(function (err) {
      if (err == undefined || err.response == undefined || err.response.status == undefined) {
        Swal.fire({
          html: '<h3>พบข้อผิดพลาดการเชื่อมต่อกับเซิฟเวอร์ กรุณาลองใหม่อีกครั้ง</h3>',
          confirmButtonText: `ปิด`,
          icon: 'error',
          didClose: () => {
            success({ sur: old });
          }
        });
      } else if (err.response.status == 401) {
        localStorage.removeItem('gpfsp');
        sessionStorage.setItem('previous', window.location.href);
        Swal.fire({
          html: '<h3>ระบบไม่ได้รับการตอบสนองจากผู้ใช้งานภายในเวลาที่กำหนด กรุณาออกจากระบบ</h3>',
          confirmButtonText: `ปิด`,
          icon: 'info',
          didClose: () => {
            window.location.href = (basename + "/user/login")
          }
        });
      } else {
        Swal.fire({
          html: '<h3>' + err.response.data.message + '</h3>',
          confirmButtonText: `ปิด`,
          icon: 'error',
          didClose: () => {
            success({ sur: old });
          }
        });
      }
    });
  })
    .then((response) => response)
    .catch((error) => error);
};


const SetActive = async (fid, item, sur) => {
  let obj = Object.assign({}, sur, {})
  obj.active = item;
  return await new Promise((success, err) => {
    const formData = new FormData();
    formData.append('surveyData', JSON.stringify(obj));
    axios.put(
      api_endpoint + '/survey/' + sur.iid + '/' + sur.id,
      formData,
      {
        headers: { 'Authorization': 'bearer ' + localStorage.getItem('gpfkey') }
      }
    ).then(r => {
      if (r !== undefined && r.status === 200) {
        axios.post(
          api_endpoint + '/getSurveyRound/' + sur.iid + '/' + sur.id,
          {},
          {
            headers: { 'Authorization': 'bearer ' + localStorage.getItem('gpfkey') }
          }
        ).then(response => {
          localStorage.setItem('gpfkey', response.data.token)
          surveyDetailData.data[0] = r.data.data[0]
          success({ sur: r.data.data[0], round: (response.data.round) });
        }).catch(function (err) {
          if (err == undefined || err.response == undefined || err.response.status == undefined) {
            Swal.fire({
              html: '<h3>พบข้อผิดพลาด กรุณาลองใหม่อีกครั้ง</h3>',
              confirmButtonText: `ปิด`,
              icon: 'error',
            });
          } else if (err.response.status == 401) {
            localStorage.removeItem('gpfsp');
            sessionStorage.setItem('previous', window.location.href);
            Swal.fire({
              html: '<h3>ระบบไม่ได้รับการตอบสนองจากผู้ใช้งานภายในเวลาที่กำหนด กรุณาออกจากระบบ</h3>',
              confirmButtonText: `ปิด`,
              icon: 'info',
              didClose: () => {
                window.location.href = (basename + "/user/login")
              }
            });
          }
        });
      }
    }).catch(function (errs) {
      if (errs == undefined || errs.response == undefined || errs.response.status == undefined) {
        Swal.fire({
          html: '<h3>พบข้อผิดพลาดการเชื่อมต่อกับเซิฟเวอร์ กรุณาลองใหม่อีกครั้ง</h3>',
          confirmButtonText: `ปิด`,
          icon: 'error',
          didClose: () => {
            success(undefined);
          }
        });
      } else if (errs.response.status == 401) {
        localStorage.removeItem('gpfsp');
        sessionStorage.setItem('previous', window.location.href);
        Swal.fire({
          html: '<h3>ระบบไม่ได้รับการตอบสนองจากผู้ใช้งานภายในเวลาที่กำหนด กรุณาออกจากระบบ</h3>',
          confirmButtonText: `ปิด`,
          icon: 'info',
          didClose: () => {
            window.location.href = (basename + "/user/login")
          }
        });
      } else {
        Swal.fire({
          html: '<h3>' + errs.response.data.message + '</h3>',
          confirmButtonText: `ปิด`,
          icon: 'error',
          didClose: () => {
            success(undefined);
          }
        });
      }
    });
  })
    .then((response) => response)
    .catch((error) => error);
};
const SetForce = async (fid, item, sur) => {
  let obj = Object.assign({}, sur, {})
  obj.forceClose = item;
  return await new Promise((success, err) => {
    axios.post(
      api_endpoint + '/surveyForceClose/' + sur.iid + '/' + sur.id,
      obj,
      {
        headers: { 'Authorization': 'bearer ' + localStorage.getItem('gpfkey') }
      }
    ).then(r => {
      if (r !== undefined && r.status === 200) {
        localStorage.setItem('gpfkey', r.data.token)
        axios.post(
          api_endpoint + '/getSurveyRound/' + sur.iid + '/' + sur.id,
          {},
          {
            headers: { 'Authorization': 'bearer ' + localStorage.getItem('gpfkey') }
          }
        ).then(response => {
          localStorage.setItem('gpfkey', response.data.token)
          surveyDetailData.data[0] = r.data.data[0]
          success({ sur: obj, round: (response.data.round) });
        }).catch(function (err) {
          if (err == undefined || err.response == undefined || err.response.status == undefined) {
            Swal.fire({
              html: '<h3>พบข้อผิดพลาด กรุณาลองใหม่อีกครั้ง</h3>',
              confirmButtonText: `ปิด`,
              icon: 'error',
            });
          } else if (err.response.status == 401) {
            localStorage.removeItem('gpfsp');
            sessionStorage.setItem('previous', window.location.href);
            Swal.fire({
              html: '<h3>ระบบไม่ได้รับการตอบสนองจากผู้ใช้งานภายในเวลาที่กำหนด กรุณาออกจากระบบ</h3>',
              confirmButtonText: `ปิด`,
              icon: 'info',
              didClose: () => {
                window.location.href = (basename + "/user/login")
              }
            });
          }
        });
      }
    }).catch(function (errs) {
      if (errs == undefined || errs.response == undefined || errs.response.status == undefined) {
        Swal.fire({
          html: '<h3>พบข้อผิดพลาดการเชื่อมต่อกับเซิฟเวอร์ กรุณาลองใหม่อีกครั้ง</h3>',
          confirmButtonText: `ปิด`,
          icon: 'error',
          didClose: () => {
            success({ sur: sur, round: undefined });
          }
        });
      } else if (errs.response.status == 401) {
        localStorage.removeItem('gpfsp');
        sessionStorage.setItem('previous', window.location.href);
        Swal.fire({
          html: '<h3>ระบบไม่ได้รับการตอบสนองจากผู้ใช้งานภายในเวลาที่กำหนด กรุณาออกจากระบบ</h3>',
          confirmButtonText: `ปิด`,
          icon: 'info',
          didClose: () => {
            window.location.href = (basename + "/user/login")
          }
        });
      } else {
        Swal.fire({
          html:
            '<h3>' + errs.response.data.message + '</h3>',
          confirmButtonText: `ปิด`,
          icon: 'error',
          didClose: () => {
            success({ sur: sur, round: undefined });
          }
        });
      }
    });
  })
    .then((response) => response)
    .catch((error) => error);
};



const mock = {
  id: 1,
  email: "chaithep.s@gpf.or.th",
  role: "owner",
  is_view: true,
  is_edit: true,
  is_delete: true,
}

let editable = 2
const getSurveyDetailRequest = async (sid) => {
  // eslint-disable-next-line no-return-await
  return await new Promise((success, err) => {
    setTimeout(() => {
      axios.post(api_endpoint + '/surveys', {}, { headers: { 'Authorization': 'bearer ' + localStorage.getItem('gpfkey') } })
        .then(function (res) {
          localStorage.setItem('gpfkey', res.data.token)
          const surveyId = sid.payload
          const arr = res.data.data;
          const index = arr.findIndex(x => x.id === surveyId);
          if (index < 0) {
            Swal.fire({
              html: '<h3>ไม่พบแบบสำรวจนี้</h3>',
              icon: 'error',
              willClose: () => {
                window.location.href = basename + adminRoot + '/survey/';
              }
            });
          } else {
            if (surveyId == arr[index].id) {
              axios.post(api_endpoint + '/survey/' + arr[index].iid + '/' + surveyId, {}, { headers: { 'Authorization': 'bearer ' + localStorage.getItem('gpfkey') } })
              .then(function (response) {
                const editable = response.data.access.editable
              
                surveyDetailData.data = []
                surveyDetailData.data.push(response.data.data[0]);
                localStorage.setItem('gpfkey', response.data.token)
                success(response.data);
              }).catch(function (error) {
                if (error == undefined || error.response == undefined || error.response.status == undefined) {
                  Swal.fire({
                    html: '<h3>' + error.response.data.message + '</h3>',
                    confirmButtonText: `ปิด`,
                    icon: 'error',
                    didClose: () => {
                      error(error);
                    }
                  });
                } else if (error.response.status == 401) {
                  localStorage.removeItem('gpfsp');
                  sessionStorage.setItem('previous', window.location.href);
                  Swal.fire({
                    html: '<h3>ระบบไม่ได้รับการตอบสนองจากผู้ใช้งานภายในเวลาที่กำหนด กรุณาออกจากระบบ</h3>',
                    confirmButtonText: `ปิด`,
                    icon: 'info',
                    didClose: () => {
                      window.location.href = (basename + "/user/login")
                    }
                  });
                }
              });
            }
          }
        }).catch(function (errs) {
          // Swal.fire({
          //   // html: '<h3>พบข้อผิดพลาดการเชื่อมต่อกับเซิฟเวอร์ กรุณาลองใหม่อีกครั้ง</h3>',
          //   html: '<h3>' + errs.response.data.message + '</h3>',
          //   confirmButtonText: `ปิด`,
          //   icon: 'error',
          //   didClose: () => {
          //     window.location.href = basename + adminRoot + '/survey/';
          //   }
          // });
          if (errs == undefined || errs.response == undefined || errs.response.status == undefined) {
            Swal.fire({
              html: '<h3>พบข้อผิดพลาดการเชื่อมต่อกับเซิฟเวอร์ กรุณาลองใหม่อีกครั้ง</h3>',
              confirmButtonText: `ปิด`,
              icon: 'error',
              // didClose: () => {
              //   success({ sur: sur, round: undefined });
              // }
              didClose: () => {
                window.location.href = basename + adminRoot + '/survey/';
              }
            });
          } else if (errs.response.status == 401) {
            localStorage.removeItem('gpfsp');
            sessionStorage.setItem('previous', window.location.href);
            Swal.fire({
              html: '<h3>ระบบไม่ได้รับการตอบสนองจากผู้ใช้งานภายในเวลาที่กำหนด กรุณาออกจากระบบ</h3>',
              confirmButtonText: `ปิด`,
              icon: 'info',
              didClose: () => {
                window.location.href = (basename + "/user/login")
              }
            });
          } else {
            Swal.fire({
              // html: '<h3>พบข้อผิดพลาดการเชื่อมต่อกับเซิฟเวอร์ กรุณาลองใหม่อีกครั้ง</h3>',
              html: '<h3>' + errs.response.data.message + '</h3>',
              confirmButtonText: `ปิด`,
              icon: 'error',
              didClose: () => {
                window.location.href = basename + adminRoot + '/survey/';
              }
            });
          }
        });
    }, 1000);
  })
    .then((response) => response)
    .catch((error) => error);
};

const deleteQuestionRequest = async (quesitonId, survey) => {
  // eslint-disable-next-line no-param-reassign
  const surveydetail = survey;
  for (let p = 0; p < surveydetail.pages.length; p += 1) {
    surveydetail.pages[p].questions = surveydetail.pages[p].questions.filter(
      (x) => x.id !== quesitonId
    );
  }
  // updateRec(surveydetail.id, surveydetail);
  // eslint-disable-next-line no-return-await
  return await new Promise((success) => {
    success(surveydetail);
  })
    .then((response) => response)
    .catch((error) => error);
};

const deleteSurveyItemRequest = async (item) => {
  const index = surveyDetailData.data.findIndex((x) => x.id === item.payload);
  return await new Promise((success) => {
    axios({
      method: 'delete',
      url: api_endpoint + '/survey/' + surveyDetailData.data[index].iid + '/' + surveyDetailData.data[index].id,
      headers: { 'Authorization': 'bearer ' + localStorage.getItem('gpfkey') }
    }).then(function (response) {
      localStorage.setItem('gpfkey', response.data.token)
      surveyDetailData.data = surveyDetailData.data.filter((x) => x.id !== item.payload);
      window.location.href = basename + adminRoot + '/survey/';
    }).catch(function (error) {
      // handle error
      if (error == undefined || error.response == undefined || error.response.status == undefined) {
        Swal.fire({
          html: '<h3>พบข้อผิดพลาดการเชื่อมต่อกับเซิฟเวอร์ กรุณาลองใหม่อีกครั้ง</h3>',
          confirmButtonText: `ปิด`,
          icon: 'error',
          didClose: () => {
            success(surveyDetailData.data[index]);
          }
        });
      } else if (error.response.status == 401) {
        localStorage.removeItem('gpfsp');
        sessionStorage.setItem('previous', window.location.href);
        Swal.fire({
          html: '<h3>ระบบไม่ได้รับการตอบสนองจากผู้ใช้งานภายในเวลาที่กำหนด กรุณาออกจากระบบ</h3>',
          confirmButtonText: `ปิด`,
          icon: 'info',
          didClose: () => {
            window.location.href = (basename + "/user/login")
          }
        });
      }
    });
  })
    .then((response) => response)
    .catch((error) => error);
  // eslint-disable-next-line no-return-await
};

function* deleteSurvey(payload) {
  try {
    const response = yield call(deleteSurveyItemRequest, payload);
    yield put(deleteSurveyItemSuccess(response));
  } catch (error) {
    yield put(deleteSurveyItemError(error));
  }
}

export function* wathcDelItem() {
  yield takeEvery(SURVEY_LIST_DEL, deleteSurvey);
}

const deletePageRequest = async (pageId, survey) => {
  // eslint-disable-next-line no-param-reassign
  const surveydetail = survey;
  surveydetail.pages = surveydetail.pages.filter((x) => x.id !== pageId);
  surveydetail.pages[0].visible = true;
  // updateRec(surveydetail.id, surveydetail);
  // eslint-disable-next-line no-return-await
  return await new Promise((success) => {
    success(surveydetail);
  })
    .then((response) => response)
    .catch((error) => error);
};

function* getSurveyDetailItems(sid) {
  try {
    const response = yield call(getSurveyDetailRequest, sid);
    yield put(getSurveyDetailSuccess(response));
  } catch (error) {
    yield put(getSurveyDetailError(error));
  }
}

function* deleteQuestion({ payload }) {
  try {
    const { questionId, survey } = payload;
    const response = yield call(deleteQuestionRequest, questionId, survey);
    yield put(saveSurvey(response));
  } catch (error) {
    yield put(getSurveyDetailError(error));
  }
}

function* deletePage({ payload }) {
  try {
    const { pageId, survey } = payload;
    const response = yield call(deletePageRequest, pageId, survey);
    yield put(saveSurvey(response));
  } catch (error) {
    yield put(getSurveyDetailError(error));
  }
}

const addQuesReq = async (formid, pageid, survey) => {
  const quesform = {
    id: uuidv4(),
    title: '',
    required: false,
    validtext: '',
    visible: true,
    family: '',
    subtype: '',
    desc: '',
    src: '',
    addtarget: false,
    other: {
      enabled: false,
      id: '',
    },
    subfix: '',
  };
  // eslint-disable-next-line no-return-await
  return await new Promise((success) => {
    const surveyset = survey;
          for (let m = 0; m < surveyset.pages.length; m += 1) {
            if (surveyset.pages[m].id === pageid) {
              surveyset.pages[m].questions.push(quesform);
              // updateRec(surveyset.id, surveyset);
              success(surveyset);
            }
          }
  })
    .then((response) => response)
    .catch((error) => error);
};

const uptFormreq = async (id, obj) => {
  // eslint-disable-next-line no-return-await
  return await new Promise((success) => {
    // updateRec(id, obj);
    success(obj);
  })
    .then((response) => response)
    .catch((error) => error);
};

function* addQuestion({ payload }) {
  try {
    const { formid, pageid, survey } = payload;
    const response = yield call(addQuesReq, formid, pageid, survey);
    yield put(saveSurvey(response));
  } catch (error) {
    yield put(getSurveyDetailError(error));
  }
}

function* uptQuestion({ payload }) {
  try {
    const { action, param, formid, pageid, quesid } = payload;
    const response = yield call(
      uptQuesReq,
      action,
      param,
      formid,
      pageid,
      quesid
    );
    yield put(saveSurvey(response));
  } catch (error) {
    yield put(getSurveyDetailError(error));
  }
}

function* uptForm({ payload }) {
  try {
    const { id, formobj } = payload;
    const response = yield call(uptFormreq, id, formobj);
    yield put(saveSurvey(response));
  } catch (error) {
    yield put(getSurveyDetailError(error));
  }
}

const uptQuesObjReq = async (formid, pageid, quesid, quesobj) => {
  // eslint-disable-next-line no-return-await
  return await new Promise((success) => {
    for (let p = 0; p < surveyDetailData.data.length; p += 1) {
      try {
        if (surveyDetailData.data[p].id === formid) {
          let surveyset = surveyDetailData.data[p];
          for (let m = 0; m < surveyset.pages.length; m += 1) {
            if (surveyset.pages[m].id === pageid) {
              for (let q = 0; q < surveyset.pages[m].questions.length; q += 1) {
                if (surveyset.pages[m].questions[q].id === quesid) {
                  surveyset.pages[m].questions[q] = quesobj;
                }
              }
            }
          }
          // updateRec(surveyset.id, surveyset);
          success(surveyset);
        }
      } catch (err) {
        window.location.href = basename + adminRoot + '/survey';
      }
    }
  })
    .then((response) => response)
    .catch((error) => error);
};
function* uptQuesObjFunc({ payload }) {
  try {
    const { formid, pageid, quesid, quesobj } = payload;
    const response = yield call(uptQuesObjReq, formid, pageid, quesid, quesobj);
    yield put(saveSurvey(response));
  } catch (error) {
    yield put(getSurveyDetailError(error));
  }
}

function* UptServerReq({ payload }) {
  try {
    const { id, sur } = payload;
    const response = yield call(UpttoServer, id, sur);
    yield put(getSurveyDetailSuccess(response));
  } catch (error) {
    yield put(getSurveyDetailError(error));
  }
}

function* UptDateServerReq({ payload }) {
  try {
    const { id, oldsur, sur } = payload;
    const response = yield call(uptDateServer, id, oldsur, sur);
    yield put(getSurveyUpt(response));
  } catch (error) {
    yield put(getSurveyDetailError(error));
  }
}

function* UptActiveReq({ payload }) {
  try {
    const { id, param, sur } = payload;
    const response = yield call(SetActive, id, param, sur);
    yield put(getSurveyUpt(response));
  } catch (error) {
    yield put(getSurveyDetailError(error));
  }
}

function* UptForceReq({ payload }) {
  try {
    const { id, param, sur } = payload;
    const response = yield call(SetForce, id, param, sur);
    yield put(getSurveyUpt(response));
  } catch (error) {
    yield put(getSurveyDetailError(error));
  }
}

export function* watchGetDetail() {
  yield takeEvery(SURVEY_GET_DETAILS, getSurveyDetailItems);
}

export function* watchUp2Server() {
  yield takeEvery(UPT_TO_SERVER, UptServerReq);
}

export function* watchSetActiveServer() {
  yield takeEvery(SET_ACTIVE, UptActiveReq);
}

export function* watchSetForceClose() {
  yield takeEvery(SET_FORCE, UptForceReq);
}

export function* watchSetLaunch() {
  yield takeEvery(UPT_LAUNCH_SERVER, UptDateServerReq);
}

export function* watchDeleteQuestion() {
  yield takeEvery(SURVEY_DELETE_QUESTION, deleteQuestion);
}

export function* watchDeletePage() {
  yield takeEvery(SURVEY_DELETE_PAGE, deletePage);
}

export function* watchAddQues() {
  yield takeEvery(ADD_QUES, addQuestion);
}
export function* watchUptQues() {
  yield takeEvery(UPT_QUES, uptQuestion);
}

export function* watchUptForm() {
  yield takeEvery(UPT_FORM, uptForm);
}

export function* watchUptQuesObj() {
  yield takeEvery(UPT_QUES_OBJ, uptQuesObjFunc);
}

export default function* rootSaga() {
  yield all([
    fork(watchGetDetail),
    fork(watchDeleteQuestion),
    fork(watchDeletePage),
    fork(watchAddQues),
    fork(watchUptQues),
    fork(watchUptForm),
    fork(watchSetLaunch),
    fork(watchUptQuesObj),
    fork(watchUp2Server),
    fork(watchSetActiveServer),
    fork(wathcDelItem),
    fork(watchSetForceClose),
  ]);
}
